import { configQuery, isCoreXQuery, languageQuery } from '@gig/magic-common';
import { GAMES_CATEGORIES_CMS_CONTENT, GAMES_LIST_CLEAR, GAMES_LIST_RELOAD, GAMES_JACKPOTS_LIST, BALANCE_CURRENCY_QUERY, GAMES_LIST, GAMES_SET_CURRENT_GAME_SLUG, GAMES_CURRENT_GAME_SLUG_UPDATED, USER_LOGGED_IN_QUERY, USER_LOGGED_IN_UPDATED, GAMES_CURRENT_GAME_UPDATED, IP_COUNTRY_QUERY, GAMES_LIST_QUERY, GAME_CMS_QUERY, GAMES_PROVIDERS, GAMES_LOADED, GAMES_SCROLL_DOWN, GAMES_CATEGORIES_LIST, GAMES_RECOMMENDED_GAMES, GAMES_RECOMMENDED_GAMES_USER } from '@gig/magic-messages';
import { __awaiter, __generator, __assign } from 'tslib';
import { magic } from '@gig/magic-sdk';
import { filterChildishGames, filterAuthRequiredGames, copyGames } from './filter-games.js';
import { openGamesDB } from './game-db.js';

var GamesService = /** @class */ (function () {
    function GamesService() {
        this.jackpots = {};
        this.viewGames = null;
        this.idsToSlugs = null;
        this.isLoggedIn = false;
        this.currentGameSlug = null;
        this.listSubscription = null;
        this.gameSubscription = null;
        this.registerHandlers();
        this.subscribeToGamesFetch();
        this.subscribeToCurrentGameChanges();
        this.subscribeToGameListClear();
        this.subscribeToCategoriesCmsContent();
    }
    GamesService.prototype.subscribeToCategoriesCmsContent = function () {
        var _this = this;
        window.queryBus.subscribe(GAMES_CATEGORIES_CMS_CONTENT, function (event) { return __awaiter(_this, void 0, void 0, function () {
            var db, category;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, openGamesDB()];
                    case 1:
                        db = _a.sent();
                        return [4 /*yield*/, db.getCategoryBySlug(event.payload)];
                    case 2:
                        category = _a.sent();
                        db.close();
                        return [2 /*return*/, category];
                }
            });
        }); });
    };
    GamesService.prototype.subscribeToGameListClear = function () {
        var _this = this;
        window.commandBus.subscribe(GAMES_LIST_CLEAR, function (event) {
            if (!_this.viewGames || !event.payload) {
                return;
            }
            // free up resources by clearing the game and categories list
            // keep only the selected game and its categories in memory
            _this.clearGamesList(event.payload);
        });
        window.commandBus.subscribe(GAMES_LIST_RELOAD, function () { return __awaiter(_this, void 0, void 0, function () {
            var db, games;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.unsubscribeQuery();
                        return [4 /*yield*/, openGamesDB()];
                    case 1:
                        db = _a.sent();
                        return [4 /*yield*/, db.get()];
                    case 2:
                        games = _a.sent();
                        db.close();
                        return [4 /*yield*/, this.updateGameList(games)];
                    case 3:
                        _a.sent();
                        this.registerQueryHandler();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    GamesService.prototype.fetchJackpots = function () {
        return __awaiter(this, void 0, void 0, function () {
            var currency, jackpots, gameIds;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, window.queryBus.query(BALANCE_CURRENCY_QUERY)];
                    case 1:
                        currency = _a.sent();
                        return [4 /*yield*/, magic.methods.games.jackpots(currency)];
                    case 2:
                        jackpots = _a.sent();
                        gameIds = Object.keys(jackpots);
                        this.jackpots = gameIds.reduce(function (acc, id) {
                            var _a;
                            var slug = _this.idsToSlugs.get(id);
                            if (!slug) {
                                return acc;
                            }
                            return __assign(__assign({}, acc), (_a = {}, _a[slug] = jackpots[id], _a));
                        }, {});
                        window.eventBus.publish(GAMES_JACKPOTS_LIST, this.jackpots);
                        return [2 /*return*/];
                }
            });
        });
    };
    GamesService.prototype.clearGamesList = function (gameSlug) {
        var game = this.viewGames.get(gameSlug);
        this.viewGames.clear();
        this.viewGames.set(gameSlug, game);
        window.eventBus.publish(GAMES_LIST, this.viewGames);
    };
    GamesService.prototype.subscribeToCurrentGameChanges = function () {
        var _this = this;
        window.commandBus.subscribe(GAMES_SET_CURRENT_GAME_SLUG, function (event) {
            _this.currentGameSlug = event.payload;
            window.eventBus.publish(GAMES_CURRENT_GAME_SLUG_UPDATED, _this.currentGameSlug);
            _this.updateCurrentGame();
        });
    };
    GamesService.prototype.updateViewGames = function (games) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.unsubscribeQuery();
                        _a = this;
                        return [4 /*yield*/, window.queryBus.query(USER_LOGGED_IN_QUERY)];
                    case 1:
                        _a.isLoggedIn = _b.sent();
                        return [4 /*yield*/, this.updateGameList(games)];
                    case 2:
                        _b.sent();
                        this.registerQueryHandler();
                        return [2 /*return*/];
                }
            });
        });
    };
    GamesService.prototype.subscribeToGamesFetch = function () {
        var _this = this;
        window.eventBus.subscribe(USER_LOGGED_IN_UPDATED, function () { return __awaiter(_this, void 0, void 0, function () {
            var db, games;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!((_a = this.viewGames) === null || _a === void 0 ? void 0 : _a.size)) {
                            return [2 /*return*/];
                        }
                        this.unsubscribeQuery();
                        return [4 /*yield*/, openGamesDB()];
                    case 1:
                        db = _b.sent();
                        return [4 /*yield*/, db.get()];
                    case 2:
                        games = _b.sent();
                        db.close();
                        return [4 /*yield*/, this.updateGameList(games)];
                    case 3:
                        _b.sent();
                        this.registerQueryHandler();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    GamesService.prototype.updateCurrentGame = function () {
        if (!this.viewGames || !this.currentGameSlug) {
            window.eventBus.publish(GAMES_CURRENT_GAME_UPDATED, null);
            return;
        }
        var game = this.viewGames.get(this.currentGameSlug);
        window.eventBus.publish(GAMES_CURRENT_GAME_UPDATED, game);
    };
    GamesService.prototype.updateGameList = function (games) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var ipCountry, lockCountries, isChildLockCountry, gameIds;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, window.queryBus.query(IP_COUNTRY_QUERY)];
                    case 1:
                        ipCountry = _b.sent();
                        return [4 /*yield*/, configQuery('countries.childLockCountries')];
                    case 2:
                        lockCountries = (_a = (_b.sent())) !== null && _a !== void 0 ? _a : [];
                        isChildLockCountry = !!ipCountry && lockCountries.includes(ipCountry);
                        if (!this.isLoggedIn && isChildLockCountry) {
                            gameIds = filterChildishGames(games);
                        }
                        else if (!this.isLoggedIn) {
                            gameIds = filterAuthRequiredGames(games);
                        }
                        else {
                            gameIds = copyGames(games);
                        }
                        return [4 /*yield*/, this.createViewGames(gameIds, games)];
                    case 3:
                        _b.sent();
                        window.eventBus.disableHistory(GAMES_LIST);
                        window.eventBus.publish(GAMES_LIST, this.viewGames);
                        this.updateCurrentGame();
                        return [2 /*return*/];
                }
            });
        });
    };
    GamesService.prototype.createViewGames = function (gameIds, games) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var language;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        (_a = this.viewGames) === null || _a === void 0 ? void 0 : _a.clear();
                        this.viewGames = new Map();
                        this.idsToSlugs = new Map();
                        return [4 /*yield*/, languageQuery()];
                    case 1:
                        language = _b.sent();
                        Array.from(gameIds.keys()).forEach(function (key) {
                            var game = games.get(key);
                            _this.viewGames.set(key, {
                                slug: game.slug,
                                gameId: game.gameId,
                                id: game.id,
                                title: game.title,
                                category: game.category,
                                categories: game.categories,
                                lobbies: game.lobbies,
                                vendor: game.customVendor || game.vendor,
                                tags: game.tags[language] || [],
                            });
                            _this.idsToSlugs.set(game.gameId.toString(), game.slug);
                        });
                        return [4 /*yield*/, isCoreXQuery()];
                    case 2:
                        if (!(_b.sent())) {
                            this.fetchJackpots();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    GamesService.prototype.registerQueryHandler = function () {
        var _this = this;
        this.listSubscription = window.queryBus.subscribe(GAMES_LIST_QUERY, function () {
            return _this.viewGames;
        });
        this.gameSubscription = window.queryBus.subscribe(GAME_CMS_QUERY, function (event) { return __awaiter(_this, void 0, void 0, function () {
            var db, game;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, openGamesDB()];
                    case 1:
                        db = _a.sent();
                        return [4 /*yield*/, db.getBySlug(event.payload)];
                    case 2:
                        game = _a.sent();
                        db.close();
                        return [2 /*return*/, game];
                }
            });
        }); });
    };
    GamesService.prototype.unsubscribeQuery = function () {
        var _a, _b;
        (_a = this.listSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        this.listSubscription = null;
        (_b = this.gameSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
        this.gameSubscription = null;
    };
    GamesService.prototype.registerHandlers = function () {
        window.eventBus.register(GAMES_PROVIDERS, {
            type: 'array',
        });
        window.eventBus.register(GAMES_LOADED, {
            type: 'boolean',
        });
        window.commandBus.register(GAMES_SCROLL_DOWN, {
            type: 'null',
        });
        window.eventBus.register(GAMES_CATEGORIES_LIST, {
            type: 'array',
        });
        window.eventBus.register(GAMES_JACKPOTS_LIST, {
            type: 'object',
        });
        window.eventBus.register(GAMES_RECOMMENDED_GAMES, {
            type: 'array',
        });
        window.eventBus.register(GAMES_RECOMMENDED_GAMES_USER, {
            type: 'array',
        });
    };
    return GamesService;
}());

export { GamesService };
